import { render, staticRenderFns } from "./channelsEdit.vue?vue&type=template&id=0cd4f6af&"
import script from "./channelsEdit.vue?vue&type=script&lang=js&"
export * from "./channelsEdit.vue?vue&type=script&lang=js&"
import style0 from "./channelsEdit.vue?vue&type=style&index=0&id=0cd4f6af&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports